<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Редактирование</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Инвентарный номер</label>
          <input
            type="text"
            class="form-control"
            name="serial_number"
            v-validate="'required'"
            v-model="machineData.serial_number"
            data-vv-as="Инвентарный номер"
          >
          <div v-if="errors.first('serial_number')" class="invalid-feedback">
            {{ errors.first('serial_number') }}
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Заводской номер <span class="text-danger">(Внимание! Эти данные будут отображаться в чеках)</span></label>
          <input type="text" class="form-control" v-model="machineData.number">
        </div>
        <div class="form-group">
          <label>Производитель</label>
          <server-select
            v-model="machineData.creator"
            endpoint="creators"
            label="name"
          />
        </div>
        <div class="form-group">
          <label>Модель</label>
          <server-select
            v-model="machineData.model"
            endpoint="models/options"
            label="name"
            :endpoint-params="{region_id: region.id}"
          />
        </div>
        <div class="form-group">
          <label>Тип места установки</label>
          <server-select
            v-model="machineData.location_type"
            endpoint="location_types"
            label="name"
          />
        </div>
        <div class="form-group">
          <label>Дата ввода в эксплуатацию</label>
          <datepicker v-model="machineData.start_time"></datepicker>
        </div>

        <div class="form-group mb-3">
          <label>Адрес <span class="text-danger">(Внимание! Эти данные будут отображаться в чеках)</span></label>
          <input type="text" class="form-control" v-model="machineData.address">
        </div>
        <div class="form-group">
          <label>Координаты установки</label>
          <map-input v-model="machineData.location"></map-input>
        </div>
        <div class="d-flex">
          <div class="custom-control custom-checkbox flex-grow-1">
            <input ref="receipt_checkbox" type="checkbox" class="custom-control-input" v-model="receiptFlag"  id="receipt-checkbox">
            <label class="custom-control-label" for="receipt-checkbox">Передача чеков</label>
          </div>
          <div class="custom-control custom-checkbox flex-grow-1">
            <input ref="qr_checkbox" type="checkbox" class="custom-control-input" v-model="machineData.qr"  id="qr-checkbox">
            <label class="custom-control-label" for="qr-checkbox">Отображение QR-кода</label>
          </div>
        </div>
        <div class="form-group mt-3">
          <label>Выбор группы ККТ</label>
          <v-multiselect
            v-model="machineData.receipt_group"
            :options="receiptGroups"
            :taggable="true"
            @tag="addTag"
            :disabled="!receiptFlag"
            :allow-empty="false"
            v-validate="{ required_if: 'receipt_checkbox,true', regex: /^[^а-яА-Я\s]+$/ }"
            name="kkt"
            data-vv-as="Группа ККТ"
          />
          <div v-if="errors.first('kkt')" class="alert alert-danger">{{ errors.first('kkt') }}</div>
        </div>
        <div class="form-group">
          <label>Оператор автомата</label>
          <server-select
            v-model="machineData.operator"
            :custom-label="fullName"
            endpoint="users_by_role"
            :endpoint-params="{role: ['service'], region_id: region.id, user_id: machineData.operator ? machineData.operator.id : null}"
          />
        </div>
        <div class="form-group">
          <label>Техник автомата</label>
          <server-select
            v-model="machineData.technician"
            :custom-label="fullName"
            endpoint="users_by_role"
            :endpoint-params="{role: ['tech'], region_id: region.id, user_id: machineData.technician ? machineData.technician.id : null}"
          />
        </div>
        <div class="form-group">
          <label>Ответственный менеджер</label>
          <server-select
            v-model="machineData.manager"
            :custom-label="fullName"
            endpoint="users_by_role"
            :endpoint-params="{role: ['dev'], region_id: region.id, user_id: machineData.manager ? machineData.manager.id : null}"
          />
        </div>
        <div class="form-group">
          <label>Арендодатель</label>
          <server-select
            v-model="machineData.lessor"
            :custom-label="fullName"
            endpoint="users_by_role"
            :endpoint-params="{role: ['lessor'], region_id: region.id, user_id: machineData.lessor ? machineData.lessor.id : null}"
          />
        </div>
        <div class="form-group">
          <label>Организация</label>
          <server-select
            v-model="machineData.division"
            endpoint="divisions/options"
            label="name"
            data-vv-as="Организация"
            name="organization"
            v-validate="'required'"
          />
          <div v-if="errors.first('organization')" class="alert alert-danger">{{ errors.first('organization') }}</div>
        </div>
        <div class="custom-control custom-checkbox">
          <input ref="gmt_checkbox" type="checkbox" class="custom-control-input" v-model="gmtFlag"  id="gmt-checkbox">
          <label class="custom-control-label" for="gmt-checkbox">
            Использовать часовой пояс организации ({{region.gmt}})
          </label>
        </div>
        <div v-if="!gmtFlag" class="form-group mt-3">
          <label>Часовой пояс</label>
          <gmt-select
            v-model="machineData.gmt"
          />
        </div>
      </div>
      <div class="modal-footer d-flex">
        <button v-if="machine && !copy" class="btn btn-danger" @click="deleteMachine()">
          Удалить ТА
        </button>
        <btn-action
          class="btn btn-primary ml-auto"
          @click="save"
        >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import { pick, omit } from 'lodash'
  import filters from '../../filters'
  import moment from 'moment'
  import MapInput from '../map-input.vue'

  export default {
    components: {
      MapInput,
    },
    props: ['machine', 'copy'],
    data () {
      return {
        machineData: {},
        receiptFlag: this.machine ? !!this.machine.receipt_group : false,
        receiptGroups: ['Main', 'vend'],
        gmtFlag: this.machine ? !this.machine.gmt : true,
      }
    },
    methods: {
      save () {
        this.$validator.validateAll().then(success => {
          if (success) {
            if (this.machine) {
              if (this.copy) {
                api.post(`machines/${this.machine.id}/copy`, this.machineData).then(() => this.hide({refresh: true}))
              } else {
                api.put(`machines/${this.machine.id}`, this.machineData).then(() => this.hide(this.machineData))
              }
            } else {
              api.post('machines', this.machineData).then(() => this.hide({refresh: true}))
            }
          }
        })
      },
      deleteMachine () {
        if (window.confirm('Вы уверены, что хотите удалить этот торговый автомат? После удаления все относящиеся к нему данные будут утеряны!')) {
          api.delete(`machines/${this.machine.id}`)
            .then((data) => {
              this.$router.push('/machines')
            })
        }
      },
      hide (data = null) {
        this.$emit('hide', data)
      },
      fullName: filters.fullName,
      addTag (tag) {
        this.receiptGroups.push(tag)
        this.machineData.receipt_group = tag
      },
    },
    watch: {
      receiptFlag () {
        this.machineData.receipt_group = this.receiptFlag ? 'Main' : null
      },
      gmtFlag () {
        if (this.gmtFlag) {
          this.machineData.gmt = null
        } else {
          this.machineData.gmt = this.region.gmt
        }
      },
    },
    computed: {
      region () {
        if (this.machine) {
          return this.machine.region
        } else {
          return this.$root.user.region
        }
      },
    },
    mounted () {
      if (this.machine) {
        this.machineData = pick(this.machine, ['number', 'serial_number', 'creator', 'model', 'location_type', 'division',
          'start_time', 'address', 'receipt_group', 'operator', 'technician', 'manager', 'lessor', 'location', 'gmt', 'qr'])

        this.machineData.start_time = moment(this.machineData.start_time).format('YYYY-MM-DD')
        if (this.copy) this.machineData = omit(this.machineData, ['number', 'serial_number'])
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/machines/modals/machine-modal.vue